


// rotationUtils.js

import { replaceUrlState } from './urlUpdaterHelper.js';

let rotationRef = null;
let setRotationFn = null;


export function initRotationUtils(ref, setter) {
    rotationRef = ref;
    setRotationFn = setter;
}


// Always normalises to range [-180, 180]
export function normaliseRotation(deg) {
    let result = deg % 360;
    if (result > 180) result -= 360;
    if (result < -180) result += 360;
    return result;
}


export function handleRotationChange(rawAngle, { updateURL = true } = {}) {
    if (!rotationRef || !setRotationFn) {
        console.log('[rotationUtils] Not initialised yet');
        return null;
    }

    const angle = normaliseRotation(rawAngle);
    rotationRef.current = angle;
    setRotationFn(angle);

    if (updateURL) {
        //console.log('Updating the URL...');
        const url = new URL(window.location);
        url.searchParams.set('r', angle.toFixed(1));
        replaceUrlState(url);
    }

    return angle;
}


export function getCurrentRotation() {
    return rotationRef?.current ?? 0;
}


